import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

export default function LandingGate({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.id) {
      navigate("/main-dashboard", { replace: true });
    }
  }, [user?.id, navigate]);

  if (user?.id) return null;
  return children;
}
